<template>
  <modal ref="modal" :title="title" :show-loading="showLoading">
    <template slot="modal-header">
      <slot name="modal-header">
        {{ title }}
      </slot>
    </template>

    <template slot="modal-body">
      <slot name="modal-body">
        Body content [ConfirmModal]
      </slot>
    </template>

    <template slot="modal-footer">
      <slot name="modal-footer">
        <button type="button" class="btn btn-default" @click="close()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="confirm()">
          {{ confirmText }}
        </button>
      </slot>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Title' },
    showLoading: { type: Boolean, default: false },
    confirmText: { type: String, default: 'Confirm' },
  },
  methods: {
    open(obj) {
      this.$refs.modal.open()
      this.obj = obj
    },
    close() {
      this.$refs.modal.close()
    },
    closeAndRedirect(route) {
      this.$refs.modal.closeAndRedirect(route)
    },
    confirm() {
      this.$emit('confirm', this.obj)
    },
  },
}
</script>
